<mat-nav-list class="p-0">
	<!-- Menú que se genera en base al array menuPrincipal -->
	<mat-list-item class="bg-primary text-light">
		Menú
	</mat-list-item>
	
	<span *ngFor="let item of mainMenu | keyvalue">
		<mat-list-item routerLink="{{item.value.enlace}}" (click)="sidenavService.close()">
			<mat-icon class="pl-0 text-primary">{{item.value.icon}}</mat-icon>
			<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
		</mat-list-item>
		<mat-divider></mat-divider>
	</span>


	<div *ngIf="user">

		<div *ngIf="userData?.userType == 'administrador'">
			<mat-list-item class="bg-primary text-light">
				Menú Administrador
			</mat-list-item>
			<span *ngFor="let item of menuAdministrator | keyvalue">
				<mat-list-item routerLink="{{item.value.enlace}}" style="border-top: #DDD 1px solid;"
					(click)="sidenavService.close()">
					<mat-icon class="pl-0 text-primary">{{item.value.icon}}</mat-icon>
					<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
				</mat-list-item>
				<mat-divider></mat-divider>
			</span>






			<!-- ======================================================================== -->
			<!-- ================================	SECCIONES		===================== -->
			<!-- ======================================================================== -->
			<mat-accordion multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header class="pl-3">
						<mat-panel-title class="text-primary pl-0">

							<mat-icon class="pl-0 text-primary">api</mat-icon>
							<span class="text-primary ml-2 pr-1">Ver por Sección</span>

						</mat-panel-title>

					</mat-expansion-panel-header>

					<span *ngFor="let item of menuPorSeccion | keyvalue">
						<mat-list-item routerLink="{{item.value.enlace}}" (click)="sidenavService.close()">
							<mat-icon class="pl-0 text-primary">chevron_right</mat-icon>
							<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
						</mat-list-item>
					</span>

				</mat-expansion-panel>
			</mat-accordion>



			<!-- ======================================================================== -->
			<!-- ================================	GESTORES		===================== -->
			<!-- ======================================================================== -->
			<mat-accordion class="example-headers-align" multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header class="pl-3">
						<mat-panel-title class="text-primary pl-0">
							<mat-icon class="pl-0 text-primary">assignment_ind</mat-icon>
							<span class="text-primary ml-2 pr-1">Ver por Gestor</span>
						</mat-panel-title>

					</mat-expansion-panel-header>

					<span *ngFor="let item of menuPorGestor | keyvalue">
						<mat-list-item routerLink="{{item.value.enlace}}" style="border-top: #DDD 1px solid;"
							(click)="sidenavService.close()">
							<mat-icon class="pl-0 text-primary">chevron_right</mat-icon>
							<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
						</mat-list-item>
					</span>

				</mat-expansion-panel>
			</mat-accordion>


			
			<!-- ======================================================================== -->
			<!-- ================================	COLONIA		===================== -->
			<!-- ======================================================================== -->
			<mat-accordion class="example-headers-align" multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header class="pl-3">
						<mat-panel-title class="text-primary pl-0">
							<mat-icon class="pl-0 text-primary">place</mat-icon>
							<span class="text-primary ml-2 pr-1">Ver por Colonia</span>
						</mat-panel-title>

					</mat-expansion-panel-header>

					<span *ngFor="let item of menuPorColonia | keyvalue">
						<mat-list-item routerLink="{{item.value.enlace}}" style="border-top: #DDD 1px solid;"
							(click)="sidenavService.close()">
							<mat-icon class="pl-0 text-primary">chevron_right</mat-icon>
							<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
						</mat-list-item>
					</span>

				</mat-expansion-panel>
			</mat-accordion>






		</div>


		<div *ngIf="userData?.userType == 'gestor'">
			<mat-list-item class="bg-primary text-light">
				Menú Gestor
			</mat-list-item>
			<span *ngFor="let item of menuGestor | keyvalue">
				<mat-list-item routerLink="{{item.value.enlace}}" style="border-top: #DDD 1px solid;"
					(click)="sidenavService.close()">
					<mat-icon class="pl-0 text-primary">{{item.value.icon}}</mat-icon>
					<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
				</mat-list-item>
				<mat-divider></mat-divider>
			</span>
		</div>


		<div *ngIf="menuUser">
			<mat-list-item class="bg-primary text-light">
				Menú Usuario
			</mat-list-item>
			<span *ngFor="let item of menuUser | keyvalue">
				<mat-list-item routerLink="{{item.value.enlace}}" style="border-top: #DDD 1px solid;"
					(click)="sidenavService.close()">
					<mat-icon class="pl-0 text-primary">{{item.value.icon}}</mat-icon>
					<span class="text-primary ml-2 pr-1">{{item.value.texto}}</span>
				</mat-list-item>
				<mat-divider></mat-divider>
			</span>
		</div>
	</div>
</mat-nav-list>